/*
 * Custom extensions to underscore
 */

import _ from 'underscore';
import $ from 'jquery';

var _deepExtend = function (target, source) {
  _.each(_.keys(source), function (key) {
    if (_.has(target, key)) {
      target[key] = _deepExtend(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  });
  return target;
};

export default {
  isPresent() {
    return _.inject(
      arguments,
      function (memo, arg) {
        return memo && !(_.isNull(arg) || _.isUndefined(arg));
      },
      true
    );
  },

  formatForUrl(place) {
    return place.replace(/\./g, '').replace(/, /g, '--').replace(/ /g, '-');
  },

  addToURLParams(url, extra_params) {
    const segments = url.split('?');
    const base = segments.shift();
    const params = $.deparam(segments.join('?'));

    _.extend(params, extra_params);
    return `${base}?${$.param(params)}`;
  },

  deepExtend: _deepExtend,
};
